<template>
    <el-dialog
        :visible="visible"
        title="Import Webpage to Knowledge Base"
        width="600px"
        :close-on-click-modal="false"
        @close="handleClose"
    >
        <div class="mb-3">
            <p>
                <small>
                    For best results, add only the specific pages that make sense for your Knowledge Base and enter one URL per line.
                    Maximum URL length: 2048 characters per URL.
                </small>
            </p>
        </div>
        <el-form :model="form">
            <el-form-item required class="no-border">
                <el-input
                    v-model="form.urls"
                    type="textarea"
                    :rows="6"
                    placeholder="Enter one webpage URL per line"
                    maxlength="10000"
                    show-word-limit
                />
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">Cancel</el-button>
            <el-button type="primary" :loading="loading" @click="handleSubmit">Import Webpages</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'ImportWebpageModal',

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        bot: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            loading: false,
            form: {
                urls: ''
            }
        }
    },

    watch: {
        visible(newVal) {
            if (!newVal) {
                this.resetForm()
            }
        }
    },

    methods: {
        handleClose() {
            this.$emit('close')
        },

        resetForm() {
            this.form = {
                urls: ''
            }
        },

        parseUrls() {
            return this.form.urls
                .split('\n')
                .map(url => url.trim())
                .filter(url => url.length > 0)
        },

        validateUrls(urls) {
            const errors = []

            for (const url of urls) {
                const schemeCount = (url.match(/https?:\/\//gi) || []).length
                if (schemeCount > 1) {
                    errors.push('Please enter one URL per line.')
                    continue
                }

                if (url.length > 2048) {
                    errors.push('One or more URLs exceed the maximum length of 2048 characters.')
                    continue
                }

                try {
                    new URL(url)
                } catch (e) {
                    errors.push('One or more URLs are invalid.')
                }
            }

            return [...new Set(errors)]
        },

        handleSubmit() {
            const urls = this.parseUrls()
            
            if (urls.length === 0) {
                this.$message.warning('Please enter at least one URL')
                return
            }

            const invalidUrls = this.validateUrls(urls)
            if (invalidUrls.length > 0) {
                this.$message.warning('Please fix the following errors:\n' + invalidUrls.join('\n'))
                return
            }

            this.loading = true
            axios.post('/api/v1/aloai/bot/' + this.bot.id + '/import-webpage', {
                urls: urls
            })
            .then((res) => {
                const count = res.data.contents?.length || urls.length
                this.$message.success(`${count} webpage${count > 1 ? 's' : ''} imported successfully`)
                this.$emit('success')
                // Close modal after success
                this.$nextTick(() => {
                    this.handleClose()
                })
            })
            .catch((err) => {
                const message = err.response?.data?.message || 'Failed to import webpages'
                this.$message.error(message)
                this.$emit('failed')
            })
            .finally(() => {
                this.loading = false
            })
        }
    }
}
</script>
